import * as React from 'react';
import { cn } from '../../lib/utils';

export type BadgeVariant = 'default' | 'secondary' | 'outline' | 'success' | 'warning';

const variants: Record<BadgeVariant, string> = {
  default: 'border-transparent bg-primary text-primary-foreground',
  secondary: 'border-transparent bg-secondary text-secondary-foreground',
  outline: 'border-border bg-transparent text-foreground',
  success: 'border-transparent bg-emerald-500/10 text-emerald-700 dark:text-emerald-300',
  warning: 'border-transparent bg-amber-500/10 text-amber-700 dark:text-amber-300',
};

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: BadgeVariant;
}

export function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  return (
    <div className={cn('inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold transition-colors', variants[variant], className)} {...props} />
  );
}
